import request from '@/utils/request'
const host = process.env.VUE_APP_ORDER_API;
const host2 = process.env.VUE_APP_PRODUCT_API
const host3 = process.env.VUE_APP_SEARCH_API
//加入购物车
export function addShoppingCart (params) {
  return request({
    url: host + 'shoppingCart/addShoppingCartProduct',
    method: 'post',
    data: params
  })
}
//查询购物车商品
export function searchShoppingCart (params) {
  return request({
    url: host + 'shoppingCart/searchShoppingCartProduct',
    method: 'get',
    params
  })
}
//查询购物车商2
export function searchShoppingCartProductNoCartProduct (params) {
  return request({
    url: host + 'shoppingCart/searchShoppingCartProductNoCartProduct',
    method: 'get',
    params
  })
}
//删除购物车商品
export function delShoppingCart (data) {
  return request({
    url: host + 'shoppingCart/delShoppingCartProductByCartIds',
    method: 'post',
    data: data
  })
}
//删除多个购物车商品
export function delShoppingCarts (data) {
  return request({
    url: host + 'shoppingCart/delShoppingCartByCartIds',
    method: 'post',
    data: data
  })
}

//修改购物车商品数量
export function addShoppingCartNum (params) {
  return request({
    url: host + 'shoppingCart/addShoppingCartProductNum',
    method: 'post',
    params
  })
}
//收藏商品
export function addCollectProduct (data) {
  return request({
    url: host + 'productCollect/addCollectProduct',
    method: 'post',
    data: data
  })
}
//查询用户收藏商品
export function searchCollectProduct (params) {
  return request({
    url: host + 'productCollect/searchCollectProduct',
    method: 'get',
    params
  })
}
//删除用户收藏商品
export function delCollectProduct (data) {
  return request({
    url: host + 'productCollect/delCollectProduct',
    method: 'post',
    data: data
  })
}
//增加用户收藏商品数量
export function addCollectProductNum (params) {
  return request({
    url: host + 'productCollect/addCollectProductNum',
    method: 'post',
    params
  })
}

//提交订单
export function commitUserOrder (data) {
  return request({
    url: host + 'order/commitUserOrder',
    method: 'post',
    data: data
  })
}
//提交订单2
export function createUserOrderTest (data) {
  return request({
    url: host + 'order/createUserOrder',
    method: 'post',
    data: data
  })
}
//提交订单新接口
export function createUserOrderSplit (data) {
  return request({
    url: host + 'order/createUserOrderSplit',
    method: 'post',
    data: data
  })
}
//查询订单状态
export function searchOrderStatusByOrderNo (params) {
  return request({
    url: host + 'order/searchOrderStatusByOrderNo',
    method: 'get',
    params
  })
}
//查询用户的订单
export function searchUserOrders (params) {
  return request({
    url: host + 'order/searchUserOrders',
    method: 'get',
    params
  })
}
// 客户取消待支付订单
export function cancelWaitOrderPay (params) {
  return request({
    url: host + 'order/cancelWaitOrderPay',
    method: 'post',
    params
  })
}
// 客户待支付订单待发货数量
export function getOrderStatusCount(params) {
         return request({
           url: host + "order/getOrderStatusCount",
           method: "get",
           params
         });
       }
// 按条件查询订单用户的订单
export function searchUserOrdersByCondition (params) {
  return request({
    url: host + 'order/searchUserOrdersByCondition',
    method: 'get',
    params
  })
}
// 按条件查询订单用户的订单v3
export function searchUserOrdersV3(data) {
         return request({
           url: host + "order/searchUserOrdersV3",
           method: "post",
           data
         });
       }
// 查询订单详情
export function searchUserOrdersDetail (params) {
  return request({
    url: host + 'order/newSearchUserOrdersDetail',
    method: 'get',
    params
  })
}

// 再次购买，添加多个规格产品到购物车
export function addShoppingCartProductAgain (data) {
  return request({
    url: host + 'shoppingCart/addShoppingCartProductAgain',
    method: 'post',
    data: data
  })
}
// 待支付的订单支付
export function waitOrderPay (params) {
  return request({
    url: host + 'order/waitOrderPay',
    method: 'get',
    params
  })
}
// 取消订单
export function WaitOrderPayOnline (params) {
  return request.get(host + '/order/canCelOrderLine', { params })
  return request({
    url: host + '/order/canCelOrderLine',
    method: 'post',
    params
  })
}
// 批量查询对应产品是否已被收藏
export function searchProductCollection (data) {
  return request({
    url: host + 'productCollect/batchSearchCollection',
    method: 'post',
    data: data
  })
}
// 查询用户的订单-V2.0
export function searchUserOrders2 (params) {
  return request({
    url: host + 'order/searchUserOrders2',
    method: 'get',
    params
  })
}
// 通过商品组ID查出加购组合skuId
export function searchAddGroupSkuIds (params) {
  return request({
    url: host2 + `product/searchAddGroupSkuIds?productId=${params}`,
    method: 'get',
  })
}
//批量添加规格产品到购物车
export function addShoppingCartProducts (params) {
  console.log(params);
  return request({
    url: host + 'shoppingCart/addShoppingCartProducts',
    method: 'post',
    data: params
  })
}
//新批量添加规格产品到购物车
export function addShoppingCartProductsForQuickOrder(params) {
         console.log(params);
         return request({
           url: host + "shoppingCart/addShoppingCartProductsForQuickOrder",
           method: "post",
           data: params
         });
       }
// 查询UDC详细信息
export function searchUdc (udcCode) {
  return request({
    // url: host,
    url: host + `oms-udc/searchUdc?domainCode=OMS&udcCode=${udcCode}`,
    // url: `http://omsapi.fat.gemsf.cn/oms-udc/searchUdc?domainCode=OMS&udcCode=${udcCode}`,
    method: 'get',
  })
}
// 查询UDC详细信息
export function searchUdcorder () {
  return request({
    // url: host,
    // url: host+`oms-udc/searchUdc?domainCode=OMS&udcCode=${udcCode}`,
    url: `http://gateway.fat.gemsf.cn/mall-order-soa/order/oms-udc/Udc/1`,
    method: 'get',
  })
}
//替代商品
export function queryProductUnits (skuId) {
  return request.get(host2 + `manageProductSku/searchProductOnRelation?skuId=${skuId}`)
}
//商品描述、用途
export function getProductInfoByProductID (productId) {
  return request.get(host2 + `/publishProduct/getProductInfoByProductID?productID=${productId}`)
}
//预约下载质检表
export function downloadQualiteTable (params) {
  return request.put(host + `cux-prod-batch/downloadQualiteTable`, params)
}
//托盘
export function queryUnpackCharge (params) {
  return request({
    url: host + 'order/queryChargePalletStandard',
    method: 'post',
    data: params
  })
}
export function queryChargePalletList (params) {
  return request({
    url: host + 'order/queryChargePalletList',
    method: 'post',
    data: params
  })
}
//查询用户购物车产品 计算满箱减价格
export function searchShoppingCartProductByCartIds (params) {
  return request({
    url: host + `shoppingCart/searchShoppingCartProductByCartIds`,
    method: 'post',
    data: params
  })
}
//查询拆箱费
export function getqueryUnpackCharge (params) {
  return request({
    url: host + 'shoppingCart/queryUnpackCharge',
    method: 'post',
    data: params
  })
}
//查商品价
export function shoppingCartByProductAmounts (params) {
  return request({
    url: host + '/shoppingCart/searchShoppingCartProductByProductAmounts',
    method: 'post',
    data: params
  })
}
//查商品价
export function productSplitByOrgId (params) {
  return request({
    url: host + '/order/productSplitByOrgId',
    method: 'post',
    data: params
  })
}
//查询用户可用芯豆
export function getAcctTransBalanceDesc (params) {
  return request.get(host + 'oms-acct-trans-balance/getAcctTransBalanceDesc', { params })
}
//AcctTransFlow明细查询
export function searchAcctTransFlow (params) {
  return request.post(host + 'oms-acct-trans-flow/searchAcctTransFlow', params)
}
//查商品价
export function validateOrderAmount (params) {
  return request({
    url: host + '/shoppingCart/validateOrderAmount',
    method: 'post',
    data: params
  })
}
//芯豆规则
export function getUdcDesc () {
  return request({
    url: host + 'oms-acct-trans-balance/getUdcDesc',
    method: 'get',
  })
}
//查询用户可用芯豆2
export function getAcctTransBalanceDesc2 (params) {
  return request.get(host + `oms-acct-trans-balance/getAcctTransBalanceDesc/${params}`)
}
//查询用户总芯豆
export function getAllAcctTransBalance(params) {
         return request.get(
           host + `oms-acct-trans-balance/getAllAcctTransBalance/${params}`
         );
       }
//查询用户芯豆余额明细
export function selectOmsAcctTransBalanceDetail(params) {
         return request.get(
           host +
             `oms-acct-trans-balance/selectOmsAcctTransBalanceDetail/${params}`
         );
       }
//查询自定义编码
export function searchCustomEncodingList (params) {
  return request.post(host + `customEncoding/searchCustomEncodingList`, params)
}
//用户选择套装新增购物车
export function addShopCarttingByChoosePackId (custPackId) {
  return request.post(host + `shoppingCart/addShopCarttingByChoosePackId`, custPackId)
}
//根据收货地址和商品数量计算物流费
export function searchLgsChargeByProductAmountsAndAdress (pramas) {
  return request.post(host + `shoppingCart/searchLgsChargeByProductAmountsAndAdress`, pramas)
}
//根据收货地址和商品数量计算物流费
export function updateShopCarttingByChoosePackId (pramas) {
  return request.post(host + `shoppingCart/updateShopCarttingByChoosePackId`, pramas)
}
//包装费
export function queryOtherChargeFee (pramas) {
  return request.post(host + `order/queryOtherChargeFee`, pramas)
}
//列表查询包装信息
export function searchCustPackonChoose (params) {
  return request({
    url: host + 'oms-cust-pack/searchCustPackonChoose',
    method: 'get',
    params
  })
}
//通过udcCode开关信息
export function getSwitchByUdcCode (udcCode) {
  return request.get(host + `oms-UdcType-type/getSwitchByUdcCode/${udcCode}`)
}
//
export function exportExcel (id) {
  return request({
    url: host + `shoppingCart/exportShopCartExcel`,
    method: 'post',
    responseType: 'blob',  //需要在此处设置请求头，设置请求的类型为blob文件流的形式
  })
}
//通过批量orderUdcCode查询UDCType详细信息
export function getOrderUdcTypeByUdcCodes (pramas) {
  return request.post(host + `shoppingCart/getOrderUdcTypeByUdcCodes`, pramas)
}
//订单导出
export function exportExcelOrder (data) {
  return request({
    url: host + `order/exportExcel`,
    method: 'post',
    responseType: 'blob',  //需要在此处设置请求头，设置请求的类型为blob文件流的形式
    data
  })

}

//下载合同
export function downloadContract (pramas) {
  return request({
    // url: 'http://gateway.dev.gemsf.cn/mall-order-soa/' + `oms-contract/downloadcontract?orderNo=${'MG2022092345058'}`,
    url: host + `oms-contract/downloadcontract?orderNo=${pramas}`,
    method: 'get',
    responseType: 'blob',  //需要在此处设置请求头，设置请求的类型为blob文件流的形式

  })

}


//新建包装详细信息
export function getInsertCustPack (pramas) {
  return request.post(host + `oms-cust-pack-detail/insertCustPack`, pramas)
}
//根据商品查询预付款
export function searchPrePaymentsByProductAmounts (pramas) {
  return request.post(host + `/shoppingCart/searchPrePaymentsByProductAmounts`, pramas)
}
//查询发票详情
export function searchOrderInvoice (params) {
  return request.get(host + `/orderInvoice/searchOrderInvoice?orderNo=${params}`,)
}
//判断是否有需要一起支付的订单
export function checkOrderIsSplit (params) {
  return request.get(host + `/order/checkOrderIsSplit?orderNo=${params}`,)
}
//查询发票详情
export function searchOrderReceiving (params) {
  return request.get(host + `/order/searchOrderReceiving?orderNo=${params}`,)
}
//查询发票详情
export function searchLogisticsInfoByOrderLine (params) {
  return request.get(host + `/orderOgisticsInfo/searchLogisticsInfoByOrderLine?orderLineIds=4383291%2C4368175%2C`,)
}
//返回支付二维码
export function commitUserOrderTest (pramas) {
  return request.post(host + `/order/providePaymentCode`, pramas)
}
//返回支付新二维码（拆单）
export function providePaymentCodeForSplit (pramas) {
  return request.post(host + `/order/providePaymentCodeForSplit`, pramas)
}
//支付页面通过订单号查询订单详情
export function searchOrdersDetailByOrderNo (orderNo) {
  return request.get(host + `/order/searchOrdersDetailByOrderNo?orderNo=${orderNo}`)
}
//支付页面通过订单号查询订单详情(新
export function searchOrdersDetailByTotalOrderNo (orderNo) {
  return request.get(host + `/order/searchOrdersDetailByTotalOrderNo?totalOrderNo=${orderNo}`)
}
//查询订单发货详情
export function searchOrderDelivery (orderNo) {
  return request.get(host + `/order/searchOrderDelivery?orderNo=${orderNo}`)
}
//查询邮箱
export function getCustomerEmail(enterpriseId) {
  return request.get(host+`/cux-prod-batch/getCustomerEmail?enterpriseId=${enterpriseId}`)
}
//生成报价单
export function buildQuotationOut (data) {
  return request({
    url: host + `/omsQuotationOut/buildQuotationOut`,
    method: 'post',
    data,
    responseType: 'blob',
  })
}
//合同下载接口
export function getContractJudge(orderNo) {
  return request({
    url: process.env.VUE_APP_GEMOMS_API +`/oms-order/getContractJudge?orderNo=${orderNo}&type=1`,
    method: 'get',
    responseType: 'blob',  //需要在此处设置请求头，设置请求的类型为blob文件流的形式
  })
}
//合同下载判断接口
export function canDown (orderNo) {
  return request.get(host + `/order/getContractJudge?orderNo=${orderNo}`)
}
//校验特价商品下单数量
export function checkCartPromotionQty (cartIds) {
  return request.get(host + `/shoppingCart/checkCartPromotionQty?cartIds=${cartIds}`)
}
//未发货订单导出excel
export function exportExcelForWait (data) {
  return request({
    url: host + `/order/exportExcelForWait`,
    method: 'post',
    responseType: 'blob',  //需要在此处设置请求头，设置请求的类型为blob文件流的形式
    data
  })
}
//根据标签分类和标签查询物料信息
export function getUdcTypedescByUdcCode(params) {
  return request.get(host + `/oms-UdcType-type/getUdcTypedescByUdcCode/${params}`)
}



// WEBPACK FOOTER //
// ./src/api/order.js